import { Injectable } from "@angular/core";
import { GuidService } from "./guid.service";
import { StorageService } from "./storage.service";

@Injectable({
    providedIn: 'root',
})
export class DeviceService {
    readonly deviceIdKey = 'deviceId';

    constructor(
        private guidService: GuidService,
        private storageService: StorageService
    ) { }

    getDeviceId = (): string => {
        const oldDeviceId = this.storageService.getItem(this.deviceIdKey) || '';
        const deviceId = oldDeviceId || this.guidService.getGuId();

        if (deviceId !== oldDeviceId)
            this.storageService.setItem(this.deviceIdKey, deviceId);

        return deviceId;
    }
}